import { userSettingsGenerator } from './helpers';

export const userSettingsGermanFullResult = userSettingsGenerator('de');
